import './Loader.css';

export default function Loader() {
  return (
  <div className="flex justify-center items-center" style={{ height: '100dvh' }}>
      <div className="custom-loader opacity-85"></div>
    </div>
  );
}
